import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

/** EN / తెలుగు switch — use in footer (`dark`) or light panels (`light`). */
const LanguageToggle = ({ className = '', variant = 'light' }) => {
  const { t, locale, setLocalePreference } = useLanguage();
  const dark = variant === 'dark';
  const wrap = dark ? 'border-white/20 bg-white/5' : 'border-gray-200 bg-gray-50/90';
  const active = 'bg-white shadow-sm text-[#14A098]';
  const idle = dark ? 'text-gray-300 hover:text-white' : 'text-gray-500 hover:text-[#0f2540]';
  return (
    <div className={`flex items-center gap-0.5 rounded-full p-0.5 border ${wrap} ${className}`}>
      <button
        type="button"
        onClick={() => setLocalePreference('en')}
        className={`px-2.5 py-1 text-[11px] font-bold rounded-full transition-colors ${locale === 'en' ? active : idle}`}
      >
        {t('nav.lang_en', 'English')}
      </button>
      <button
        type="button"
        onClick={() => setLocalePreference('te')}
        className={`px-2.5 py-1 text-[11px] font-bold rounded-full transition-colors ${locale === 'te' ? active : idle}`}
      >
        {t('nav.lang_te', 'తెలుగు')}
      </button>
    </div>
  );
};

export default LanguageToggle;
